import { useQuery } from "@tanstack/react-query";
import { callFunction } from "../lib/api";
import { mapResponse, ResponseRow } from "../lib/match";
import { Response } from "../types";

const fetchResponses = async (matchId: string): Promise<Response[]> => {
  const data = (await callFunction(
    `/get-responses?match_id=${matchId}`
  )) as ResponseRow[];
  return (data || []).map(mapResponse);
};

export const useGetResponses = (matchId: string | undefined) => {
  return useQuery({
    queryKey: ["responses", matchId],
    queryFn: () => {
      if (!matchId) {
        throw new Error("Match ID is required");
      }
      return fetchResponses(matchId);
    },
    enabled: !!matchId,
  });
};
